import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { ButtonSecondary, BaseText, Heading } from '@warrenbrasil/nebraska-web';

import { ITemplateStrategyData } from './types';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { forceDownloadHref } from '@/modules/common/helpers/force-download';

interface Props {
  data: ITemplateStrategyData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateStrategy',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: ITemplateStrategyData;
}



const isDownloadingReport = ref(false);

const title = computed(() => {
  return props.data?.title || '-';
});

const description = computed(() => {
  return props.data?.description || '-';
});

const hasButton = computed(() => {
  return props.data?.report?.url;
});

const buttonLabel = computed(() => {
  return props.data?.report?.label || '';
});

const handleDownloadReport = async () => {
  try {
    isDownloadingReport.value = true;

    const url = props.data?.report?.url;
    const filename = props.data?.report?.filename ?? 'Relatório';

    await downloadResource(url || '', filename);
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Ocorreu um problema ao baixar o relatório. Tente novamente mais tarde.',
      type: NotificationTypes.error
    });
  } finally {
    isDownloadingReport.value = false;
  }
};

const downloadResource = async (url: string, filename: string) => {
  const data = await fetch(url, {
    headers: new Headers({
      Origin: location.origin
    }),
    mode: 'cors'
  });

  const blob = await data.blob();

  const blobUrl = window.URL.createObjectURL(blob);
  forceDownloadHref(blobUrl, filename);
};

return { __sfc: true,props, isDownloadingReport, title, description, hasButton, buttonLabel, handleDownloadReport, downloadResource, ButtonSecondary, BaseText, Heading }
}

})